<!-- 项目 -->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="$router.push('/project/form')">新增</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :edit-rules="validRules"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
          <el-button
            type="text"
            size="mini"
            icon="el-icon-edit"
            style="color:#4084B7"
            @click="edit(scope.row)"
          ></el-button>
          <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button
                :loading="delLoading"
                type="primary"
                size="mini"
                @click="subDelete(scope.row.id)"
              >确定</el-button>
            </div>
            <el-button
              type="text"
              size="mini"
              icon="el-icon-delete"
              slot="reference"
            ></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { deleteProject } from "@/api/project";
export default {
  name: "Demo",
  directives: {},
  filters: {},
  mixins: [DataTableMixin],
  props: {},
  components: {
    DynamicSearch
  },
  data() {
    return {
      delLoading: false,
      tableHead: [
        {
          prop: "code",
          label: "项目号",
          editRender: { name: "ElInputNumber" },
          query: {
            type: "input"
          }
        },
        {
          prop: "name",
          label: "项目名称",
          editRender: { type: "number", name: "ElInput" },
          query: {
            type: "input"
          }
        },
        {
          prop: "customer.name",
          label: "客户",
          editRender: { name: "ElSelect" }
          // query: {
          //   type: "input"
          // }
        },
        {
          prop: "remark",
          label: "备注",
          editRender: { name: "ElInput" }
        }
      ],
      validRules: {
        code: [{ required: true, message: "请输入键值", trigger: "blur" }],
        name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        customer: [{ required: true, message: "客户不能为空", trigger: "blur" }]
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      // console.log(1);
      this.dataTableInit();
    });
  },
  methods: {
    editActiveEvent(row, column) {
      console.log(row, column);
    },
    // 表格数据接口参数设置
    dataTableBeforeInit() {
      this._url = `/bsProject`;
      const params = { page: this.page, size: this.offset,};
      this._params = Object.assign(params, this._query);
      return true;
    },
    handleDeletes(rows) {
      rows.forEach(element => {
        this.subDelete(element.id);
      });
    },
    subDelete(id) {
      this.delLoading = true;
      deleteProject(id)
        .then(res => {
          this.delLoading = false;
          this.$refs[id].doClose();
          this.dleTableChangePage();
          this.dataTableInit();
          this.$notify({
            title: "删除成功",
            type: "success",
            duration: 2500
          });
        })
        .catch(err => {
          this.delLoading = false;
          this.$refs[id].doClose();
          console.log(err);
        });
    },
    edit(row) {
      this.$router.push(`/project/form?id=${row.id}`);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>